export default __webpack_public_path__ + "static/media/phone_airdrop.3867dfb9.jpg";